import React from "react";
import { createRoot } from "react-dom/client";

export function mountReactComponents(componentContext) {
  const getComponentByName = (componentName) => {
    try {
      return componentContext(`./${componentName}/${componentName}`).default;
    } catch (err) {
      console.error(`Component "${componentName}" not found.`);
      return null;
    }
  };

  document.querySelectorAll(".react-root").forEach((el) => {
    const componentName = el.dataset.reactClass;
    const props = JSON.parse(el.dataset.props || "{}");

    const Component = getComponentByName(componentName);
    if (Component) {
      createRoot(el).render(<Component {...props} />);
    }
  });
}
